<template>
  <el-dialog title="Lager" :visible="show" @close="$emit('close')">
    <product-variations-warehouses
      :product-variations-warehouses="productVariationsWarehouses"
    />
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import ProductVariationsWarehouses from 'src/components/product-variations-warehouses'

export default {
  components: {
    [Dialog.name]: Dialog,
    ProductVariationsWarehouses
  },
  props: ['show', 'productVariationsWarehouses']
}
</script>

<style>
</style>
